<template>
  <div class="contentBox">
    <div class="container">
      <div class="article">
        <div class="text page-title">Yêu cầu hủy tài khoản game</div>
        <div class="text">
          Nếu tài khoản của bạn là tài khoản Khách, vui lòng liên kết với bất kỳ
          tài khoản đang có trong trò chơi trước khi tiến hành yêu cầu hủy tài
          khoản.
        </div>
      </div>
      <div class="btn mt auto-footer active" @click="handleReturn">
        Return<!---->
      </div>
    </div>
    <div data-v-0186101b="" class="mt-logo"></div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleReturn() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./css/index.css";
</style>
